import React, { memo, useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '@/store';
import { useStateCallbackRef } from '../hooks';
import { getReviewsList, getUserLikedReviews } from '../actions/reviews.actions';
import YotpoReviewsWidget from './YotpoReviewsWidget';
import { Link } from '@components/Link';

const ProductReviews = () => {
  const dispatch = useAppDispatch();
  const { details, site } = useSelector((state: any) => state.pdpItem);

  useEffect(() => {
    dispatch(getUserLikedReviews());
  }, [dispatch]);

  const [anchor, anchorCallbackRef] = useStateCallbackRef();
  useEffect(() => {
    if (!anchor || window.location.hash !== '#reviews') return;

    const scrollToAnchor = () => {
      window.scrollTo(0, anchor.offsetTop);
    };

    if (document.readyState === 'complete') {
      scrollToAnchor();
      return;
    } else {
      window.addEventListener('load', scrollToAnchor);

      return () => window.removeEventListener('load', scrollToAnchor);
    }
  }, [anchor]);

  return details ? (
    <section className='tw:py-5 tw:px-4 tw:max-w-[870px] tw:mx-auto'>
      <Link id='reviews' ref={anchorCallbackRef} />
      <div className='container-fluid'>
        <div className='row'>
          <div className='col-12'>
            <h2>Ratings &amp; Reviews</h2>
          </div>

          <div className='row'>
            <div className='col-12'>
              <YotpoReviewsWidget
                productId={`${Math.abs(details.itemId)}-${details.uom.id}`}
                price={`${details.rate}`}
                currency='USD'
                name={details.displayName}
                url={`${site.url}${details.url}`}
                image={details.webImages.default.active.url}
                description={details.metaDescription}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  ) : null;
};

export default memo(ProductReviews);
